import React, { ReactNode, createRef } from 'react';
import classNames from 'classnames';
import { eventsHandler } from './eventsHandler';
import { PopoverPortal } from './PopoverPortal';
import { getPosition, getStyles } from './positionUtils';

type Props = {
  children: () => ReactNode;
  element: HTMLElement;
  getCursorPosition: Function;
  isPopoverInsideModal: boolean;
};

type State = {
  show: boolean;
  popoverStyle: {};
};

export class Popover extends React.Component<Props, State> {
  popoverRef = createRef<HTMLDivElement>();

  state: State = { show: false, popoverStyle: {} };

  componentDidMount() {
    eventsHandler({
      linkElement: this.props.element,
      show: this.show,
      hide: this.hide,
    });
  }

  show = (cb: Function) => {
    const cursorPosition = this.props.getCursorPosition();

    const { popoverYPosition, popoverXPosition } = getPosition({
      window,
      cursorPosition,
    });
    const { popoverStyle } = getStyles({
      popoverYPosition,
      popoverXPosition,
      window,
      cursorPosition,
    });
    this.setState({ show: true, popoverStyle }, () =>
      cb(this.popoverRef.current),
    );
  };

  hide = () => {
    this.setState({ show: false });
  };

  render() {
    const { isPopoverInsideModal } = this.props;
    const { show, popoverStyle } = this.state;

    if (!show) return null;

    return (
      <PopoverPortal>
        <div
          ref={this.popoverRef}
          className={classNames('popover-pane', {
            'popover-in-modal': isPopoverInsideModal,
          })}
          style={{ display: 'block', ...popoverStyle }}
        >
          {this.props.children()}
        </div>
      </PopoverPortal>
    );
  }
}
